import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "react-emotion";

const StyledLabel = styled("label")`
  display: inline-block;
  color: ${({ disabled }) => (disabled ? "grey" : "black")};
  input[type="checkbox"] {
    margin: 0 0 0.188em 0.313em;
    vertical-align: middle;
  }
`;

export default class Checkbox extends Component {
  static propTypes = {
    className: PropTypes.string,
    checked: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    disabled: false
  };

  toggle = e => {
    this.props.onChange(e);
  };

  render = () => {
    let classNames = ["check-box"];
    if (this.props.className) {
      classNames.push(this.props.className);
    }
    return (
      <StyledLabel
        className={classNames.join(" ")}
        disabled={this.props.disabled}
      >
        {this.props.label}
        <input
          type="checkbox"
          value={this.props.label}
          checked={this.props.checked}
          onChange={this.props.onChange ? this.toggle : undefined}
          disabled={this.props.disabled}
        />
      </StyledLabel>
    );
  };
}
